/*
  Wish list (9 Sept, storage moved to Swish 10 Sept).

  Bianca: "we just want it to be an easy way for people to save an item to
  their wish list. Typically when they're scrolling down the page there might
  be a love heart in the top right hand corner that's grey, and then when
  they click it, it then goes full and it gets added into their wish list...
  and then they can send this to someone as a hint, like this is what I'm
  after." Then: "it did save to their account. So when they log in, their
  favourite list is there. They don't lose it."

  WHERE THE LIST LIVES. The Swish (Wishlist King) app, which keeps it against
  a session for a guest and against the customer once they log in, so it
  follows them to another device. That was the whole point of adding an app:
  a Liquid theme cannot write to a customer record, only an app can.

  TWO STORES, AND SWISH IS NOT ALWAYS THE ONE IN CHARGE. Their app is lazy
  loaded from a CDN, so for the first moment of every page there is no Swish,
  and if the script is blocked or fails there never will be. A heart that
  does nothing in either case would be worse than no heart, so this keeps the
  original device list as a fallback: every write before Swish answers goes
  to localStorage, and the moment Swish appears anything held locally is
  migrated up and the local copy is dropped. Nobody loses a save either way.

  THE API, read off the live object rather than from their docs, which are
  thin and out of date for this version (5.29.0):
    window.WishlistKing.state.observeWishlist({wishlistId:'mine'})
      .subscribe(fn)                       read and watch, emits {items,...}
    WishlistKing.addWishlistItem({productHandle, productId, variantId})
                                           productHandle is REQUIRED
    WishlistKing.removeWishlistItem({wishlistItemId})
                                           THEIR id, not the product's
  The observable emits twice per change: an optimistic item with a temp id,
  then the settled one with a real id and the full product. A removal needs
  the real id, so a click on a piece that is still settling is queued rather
  than dropped.

  HANDLES ARE STILL THE CURRENCY of everything built on top of the list: the
  share link, the /products/<handle>?view=card render that draws the wish
  list page, and the pieces in the hint email. Swish stores the handle on
  every item, so none of that had to change.
*/
(function () {
  var KEY = 'wn:wishlist:v1';
  var MIGRATED = 'wn:wishlist:swished';
  var EVT = 'wn:wishlist';
  var MAX = 60;

  /* ---- the device list, now only a fallback --------------------------- */

  function localRead() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var list = JSON.parse(raw);
      if (!Array.isArray(list)) return [];
      return list.filter(function (h) { return typeof h === 'string' && h.length > 0; });
    } catch (e) { return []; }
  }

  function localWrite(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }

  /* ---- which store is in charge --------------------------------------- */

  var mode = 'local';
  var items = [];

  /* WHAT THE SHOPPER HAS ASKED FOR, while Swish is still catching up. A
     heart has to answer a tap at once, but the list it reads from does not
     change until their API has come back, so without this the heart would
     paint itself off again on the next emission and flicker. */
  var intent = {};

  function read() {
    var list;
    if (mode === 'swish') {
      list = items.map(function (i) { return i.handle; }).filter(Boolean);
    } else {
      list = localRead();
    }
    Object.keys(intent).forEach(function (h) {
      var at = list.indexOf(h);
      if (intent[h] && at === -1) list.unshift(h);
      if (!intent[h] && at !== -1) list.splice(at, 1);
    });
    return list;
  }

  function has(handle) { return read().indexOf(handle) !== -1; }

  function itemFor(handle) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === handle) return items[i];
    }
    return null;
  }

  function settledItem(handle) {
    var it = itemFor(handle);
    return !!(it && it.itemId && it.itemId.indexOf('temp-') !== 0);
  }

  /* ---- one at a time --------------------------------------------------

     THE TRAP, found by adding two pieces in a row: every mutation on
     WishlistKing.state opens with `if (locked) return;` and the lock is not
     released when the promise resolves, it is released when their own reload
     of the wishlist finishes. So a second call made too soon is dropped
     SILENTLY, returning undefined. Two hearts tapped quickly, or Save all on
     a shared list, would have saved one piece and quietly lost the rest.

     So every call goes through this queue, and each one waits for the list
     to actually show the change (or six seconds) before the next one runs.
  --------------------------------------------------------------------- */

  var chain = Promise.resolve();

  function queue(run) {
    chain = chain.then(function () { return run(); }).catch(function () { return false; });
    return chain;
  }

  function settled(test, ms) {
    return new Promise(function (resolve) {
      if (test()) { resolve(true); return; }
      var finished = false;
      function stop(value) {
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        document.removeEventListener(EVT, onChange);
        resolve(value);
      }
      function onChange() { if (test()) stop(true); }
      var timer = window.setTimeout(function () { stop(false); }, ms || 6000);
      document.addEventListener(EVT, onChange);
    });
  }

  /* The ids Swish needs. A rendered heart already carries them; anything
     else (a handle arriving from a shared link) is looked up once. */
  function idsFor(handle) {
    var btn = document.querySelector('[data-wn-wish][data-handle="' + handle + '"]');
    if (btn && btn.getAttribute('data-product-id') && btn.getAttribute('data-variant-id')) {
      return Promise.resolve({
        productHandle: handle,
        productId: parseInt(btn.getAttribute('data-product-id'), 10),
        variantId: parseInt(btn.getAttribute('data-variant-id'), 10)
      });
    }
    return window.fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.id) return null;
        var v = (p.variants && p.variants[0]) || null;
        return { productHandle: p.handle, productId: p.id, variantId: v ? v.id : null };
      })
      .catch(function () { return null; });
  }

  /* Returns a promise, so Save all on a shared list can wait for the lot
     before it navigates. */
  function add(handle, ids) {
    if (!handle) return Promise.resolve(false);

    if (mode !== 'swish') {
      var list = localRead();
      if (list.indexOf(handle) === -1) { list.unshift(handle); localWrite(list); announce(); }
      return Promise.resolve(true);
    }

    if (has(handle)) return Promise.resolve(false);
    intent[handle] = true;
    announce();

    return queue(function () {
      return (ids ? Promise.resolve(ids) : idsFor(handle)).then(function (got) {
        if (!got) { delete intent[handle]; announce(); return false; }
        window.WishlistKing.addWishlistItem(got);
        return settled(function () { return settledItem(handle); }).then(function (ok) {
          delete intent[handle];
          announce();
          return ok;
        });
      });
    });
  }

  function remove(handle) {
    if (!handle) return Promise.resolve(false);

    if (mode !== 'swish') {
      var list = localRead();
      var i = list.indexOf(handle);
      if (i !== -1) { list.splice(i, 1); localWrite(list); announce(); }
      return Promise.resolve(true);
    }

    if (!has(handle)) return Promise.resolve(false);
    intent[handle] = false;
    announce();

    return queue(function () {
      /* It may still be settling from its own add, and a removal needs the
         real id rather than the temporary one. */
      return settled(function () { return settledItem(handle) || !itemFor(handle); }).then(function () {
        var it = itemFor(handle);
        if (!it) { delete intent[handle]; announce(); return false; }
        window.WishlistKing.removeWishlistItem({ wishlistItemId: it.itemId });
        return settled(function () { return !itemFor(handle); }).then(function (ok) {
          delete intent[handle];
          announce();
          return ok;
        });
      });
    });
  }

  function toggle(handle, ids) {
    if (has(handle)) { remove(handle); return false; }
    add(handle, ids);
    return true;
  }

  function clear() {
    if (mode !== 'swish') {
      localWrite([]);
      announce();
      return Promise.resolve(true);
    }
    intent = {};
    return queue(function () {
      window.WishlistKing.clearWishlist();
      return settled(function () { return items.length === 0; });
    });
  }

  function announce() {
    document.dispatchEvent(new CustomEvent(EVT, { detail: { list: read(), mode: mode } }));
  }

  window.wnWishlist = {
    read: read, has: has, add: add, remove: remove, toggle: toggle, clear: clear,
    key: KEY, event: EVT,
    mode: function () { return mode; }
  };

  /* ---- Swish, once it turns up ---------------------------------------- */

  function sync(wishlist) {
    items = ((wishlist && wishlist.items) || []).map(function (it) {
      return {
        handle: it.product && it.product.handle,
        itemId: it.id,
        variantId: it.variantId,
        product: it.product
      };
    }).filter(function (i) { return i.handle; });

    announce();
  }

  /* Everything saved before Swish answered, handed over once. The local copy
     is dropped afterwards so a piece somebody has since removed cannot come
     back on the next page. */
  function migrate() {
    var pending = localRead();
    try { window.localStorage.setItem(MIGRATED, '1'); } catch (e) {}
    localWrite([]);
    if (!pending.length) return;
    pending.slice().reverse().forEach(function (handle) { add(handle); });
  }

  function connect() {
    var W = window.WishlistKing;
    if (!W || !W.state || typeof W.state.observeWishlist !== 'function') return false;
    var stream;
    try { stream = W.state.observeWishlist({ wishlistId: 'mine' }); } catch (e) { return false; }
    if (!stream || typeof stream.subscribe !== 'function') return false;
    mode = 'swish';
    stream.subscribe(sync);
    migrate();
    announce();
    return true;
  }

  function waitForSwish() {
    if (connect()) return;
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (connect() || tries > 66) window.clearInterval(timer);
    }, 300);
  }

  /* ---- the hearts, wherever they are on the page ---------------------- */

  function paint(btn) {
    var on = has(btn.getAttribute('data-handle'));
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = btn.getAttribute(on ? 'data-label-on' : 'data-label-off');
    if (label) { btn.setAttribute('aria-label', label); btn.setAttribute('title', label); }
    var text = btn.querySelector('[data-wn-wish-label]');
    if (text) text.textContent = on ? (btn.getAttribute('data-text-on') || 'Saved') : (btn.getAttribute('data-text-off') || 'Save');
  }

  function paintAll() {
    var btns = document.querySelectorAll('[data-wn-wish]');
    for (var i = 0; i < btns.length; i++) paint(btns[i]);

    var n = read().length;
    var counts = document.querySelectorAll('[data-wn-wish-count]');
    for (var j = 0; j < counts.length; j++) {
      counts[j].textContent = n ? String(n) : '';
      counts[j].hidden = n === 0;
    }
    var links = document.querySelectorAll('[data-wn-wish-link]');
    for (var k = 0; k < links.length; k++) links[k].classList.toggle('has-items', n > 0);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-wn-wish]') : null;
    if (!btn) return;
    /* The product card is a link. The heart sits outside that anchor so the
       markup stays valid, but stop the event anyway in case a card is ever
       wrapped in one. */
    e.preventDefault();
    e.stopPropagation();

    /* The ids come off the button, so Swish never has to look the piece up
       for a save made from a card. */
    var handle = btn.getAttribute('data-handle');
    var pid = parseInt(btn.getAttribute('data-product-id'), 10);
    var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
    var ids = (handle && pid && vid) ? { productHandle: handle, productId: pid, variantId: vid } : null;

    var on = toggle(handle, ids);
    /* Swish confirms through the observable a moment later. Paint the state
       we are asking for now, so the heart answers the tap immediately. */
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (on) {
      btn.classList.remove('is-just');
      void btn.offsetWidth;
      btn.classList.add('is-just');
    }
  });

  document.addEventListener(EVT, paintAll);

  /* Saved in another tab. Same shopper, same list, so keep them in step. */
  window.addEventListener('storage', function (e) {
    if (!e.key || e.key === KEY) paintAll();
  });

  /* Cards arrive after load in places (search, recommendations, the wish
     list page itself), so watch for new hearts rather than painting once.
     childList only: paint() changes attributes and classes, which are not
     observed, so this cannot feed itself. */
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches('[data-wn-wish]')) || (n.querySelector && n.querySelector('[data-wn-wish]'))) {
            paintAll();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---- the wish list page -------------------------------------------- */

  function param(name) {
    var m = new RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
  }

  function shareUrl(list) {
    return window.location.origin + window.location.pathname + '?p=' + list.join(',');
  }

  function renderPage() {
    var root = document.querySelector('[data-wn-wishlist]');
    if (!root) return;

    var grid = root.querySelector('[data-wn-wishlist-grid]');
    var shared = param('p');
    var list = shared ? shared.split(',').filter(Boolean) : read();

    root.setAttribute('data-mode', shared ? 'shared' : 'mine');
    root.setAttribute('data-state', list.length ? 'full' : 'empty');
    drawnMode = mode;
    grid.innerHTML = '';
    if (!list.length) return;

    /* While the cards are still arriving the grid holds empty cells with no
       handle in them, so reconcilePage would read that as "fewer showing
       than saved" and start the whole render again. This flag is what stops
       the two functions calling each other. */
    var pending = list.length;
    var kept = 0;
    root.setAttribute('data-loading', 'true');

    function settle() {
      if (pending > 0) return;
      root.removeAttribute('data-loading');
      if (kept === 0) root.setAttribute('data-state', 'empty');
    }

    list.forEach(function (handle) {
      var cell = document.createElement('div');
      cell.className = 'wn-wishcell';
      grid.appendChild(cell);

      window.fetch('/products/' + encodeURIComponent(handle) + '?view=card', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          pending -= 1;
          if (!html || html.indexOf('wn-card') === -1) {
            /* Gone from the shop, or never existed. Drop it quietly rather
               than leaving a hole, and stop carrying it around. */
            if (cell.parentNode) cell.parentNode.removeChild(cell);
            if (!shared) remove(handle);
          } else {
            cell.innerHTML = html.trim();
            kept += 1;
            paintAll();
          }
          settle();
        })
        .catch(function () {
          pending -= 1;
          if (cell.parentNode) cell.parentNode.removeChild(cell);
          settle();
        });
    });
  }

  function pageActions() {
    var root = document.querySelector('[data-wn-wishlist]');
    if (!root) return;

    var share = root.querySelector('[data-wn-wish-share]');
    if (share) {
      share.addEventListener('click', function () {
        var list = read();
        if (!list.length) return;
        var url = shareUrl(list);
        var done = function () {
          var old = share.getAttribute('data-text-done') || 'Link copied';
          var was = share.textContent;
          share.textContent = old;
          window.setTimeout(function () { share.textContent = was; }, 2400);
        };
        if (window.navigator.clipboard && window.navigator.clipboard.writeText) {
          window.navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link', url); });
        } else {
          window.prompt('Copy this link', url);
        }
      });
    }

    var saveAll = root.querySelector('[data-wn-wish-saveall]');
    if (saveAll) {
      saveAll.addEventListener('click', function () {
        var incoming = param('p').split(',').filter(Boolean);
        /* No hearts are rendered for a shared list, so each handle has to be
           looked up before Swish will take it. Wait for them all, then go. */
        saveAll.disabled = true;
        Promise.all(incoming.slice().reverse().map(function (handle) {
          return add(handle);
        })).then(function () {
          window.location.href = window.location.pathname;
        });
      });
    }

    var clearBtn = root.querySelector('[data-wn-wish-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        clear();
        renderPage();
      });
    }
  }

  /* On the wish list page itself, taking a heart off should take the piece
     off the page. Anything added while the page is open (another tab) means
     a fresh render instead. */
  var drawnMode = null;
  function reconcilePage() {
    var root = document.querySelector('[data-wn-wishlist]');
    if (!root || root.getAttribute('data-mode') === 'shared') return;
    if (root.hasAttribute('data-loading')) return;

    /* On a cold load the page is drawn from the device list for a moment and
       then Swish takes over. That is a change of store, not a change of one
       piece, so it gets a clean redraw rather than a cell by cell tidy. */
    if (drawnMode !== mode) {
      drawnMode = mode;
      renderPage();
      return;
    }

    var grid = root.querySelector('[data-wn-wishlist-grid]');
    var cells = grid.querySelectorAll('.wn-wishcell');
    var list = read();
    var showing = 0;

    for (var i = 0; i < cells.length; i++) {
      var btn = cells[i].querySelector('[data-wn-wish]');
      var handle = btn ? btn.getAttribute('data-handle') : null;
      if (handle && list.indexOf(handle) === -1) {
        cells[i].parentNode.removeChild(cells[i]);
      } else if (handle) {
        showing += 1;
      }
    }

    if (list.length > showing) { renderPage(); return; }
    root.setAttribute('data-state', showing ? 'full' : 'empty');
  }

  /* ---- send it as a hint ---------------------------------------------

     Bianca: "when they click on it, they can actually then go and click,
     like, hint to someone. So they can then add that wish list in, and then
     it sends out an email and shows them exactly the pieces in the email,
     like a style guide."

     Same two-event pattern as the bespoke enquiry, and for the same reason:
     a Klaviyo flow email always goes to the profile that triggered it, and
     there is no way to redirect one to a different address. So the event
     that drives the email fires on the RECIPIENT'S profile, and a second
     one fires on the studio's so Bianca can see the hints going out.

     Never klaviyo.identify() for either of them. The onsite klaviyo object
     holds ONE active profile per browser, so identifying the recipient
     would overwrite the shopper's own identity and poison every later
     event from that browser. The client events endpoint names the profile
     per call instead.

     ANTI-ABUSE, because this sends mail to an address a stranger typed: a
     honeypot field, a minimum dwell time, and a per-device cap. All three
     fail silently, so a bot learns nothing from the response.
  ---------------------------------------------------------------------- */

  var HINT_LOG = 'wn:wishlist:hints';
  var HINT_MAX = 3;
  var HINT_WINDOW = 60 * 60 * 1000;
  var HINT_DWELL = 2500;

  function hintsRecent() {
    try {
      var raw = window.localStorage.getItem(HINT_LOG);
      var list = raw ? JSON.parse(raw) : [];
      var cut = Date.now() - HINT_WINDOW;
      if (!Array.isArray(list)) return [];
      return list.filter(function (t) { return typeof t === 'number' && t > cut; });
    } catch (e) { return []; }
  }

  function hintLog() {
    var list = hintsRecent();
    list.push(Date.now());
    try { window.localStorage.setItem(HINT_LOG, JSON.stringify(list)); } catch (e) {}
  }

  function money(cents) {
    var n = (cents || 0) / 100;
    try {
      return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) { return '$' + n.toFixed(2); }
  }

  /* One entry per saved piece, in the order they are on the page, ready for
     the email to loop over. Anything that has gone from the shop is left
     out rather than sent as a broken row. */
  function hintItems(handles) {
    return Promise.all(handles.map(function (handle) {
      return window.fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.title) return null;
          var img = p.featured_image || (p.images && p.images[0]) || '';
          if (img.indexOf('//') === 0) img = 'https:' + img;
          if (img) img = img.split('?')[0] + '?width=600';
          return {
            title: p.title,
            url: window.location.origin + '/products/' + p.handle,
            image: img,
            price: money(p.price)
          };
        })
        .catch(function () { return null; });
    })).then(function (all) {
      return all.filter(Boolean);
    });
  }

  function klaviyoEvent(company, metric, email, props) {
    return window.fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      mode: 'cors',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties: props,
            metric: { data: { type: 'metric', attributes: { name: metric } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }
        }
      })
    }).then(function (r) {
      if (!r || !r.ok) throw new Error('klaviyo ' + (r && r.status));
      return true;
    });
  }

  function hintForm() {
    var root = document.querySelector('[data-wn-wishlist]');
    if (!root) return;
    var form = root.querySelector('[data-wn-hint-form]');
    if (!form) return;

    var box = root.querySelector('[data-wn-hint]');
    var opener = root.querySelector('[data-wn-hint-open]');
    var status = form.querySelector('[data-wn-hint-status]');
    var submit = form.querySelector('[data-wn-hint-submit]');
    var done = root.querySelector('[data-wn-hint-done]');
    var doneLine = root.querySelector('[data-wn-hint-done-line]');
    var openedAt = 0;

    function copy(name, fallback) {
      return form.getAttribute('data-' + name) || fallback;
    }
    function field(name) {
      var el = form.elements[name];
      return el && el.value ? el.value.trim() : '';
    }
    function say(text, bad) {
      status.textContent = text;
      status.classList.toggle('is-bad', !!bad);
    }
    function finish(email) {
      form.hidden = true;
      if (done) {
        done.hidden = false;
        if (doneLine) doneLine.textContent = copy('done-text', 'We have sent it to') + ' ' + email + '.';
        done.setAttribute('tabindex', '-1');
        done.focus({ preventScroll: true });
      }
    }

    if (opener && box) {
      opener.addEventListener('click', function () {
        var opening = box.hidden;
        box.hidden = !opening;
        opener.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (opening) {
          openedAt = Date.now();
          var first = form.elements.from_name;
          if (first) first.focus();
        }
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var to = field('to_email');
      var from = field('from_name');
      var list = read();

      /* The three quiet ones. Show the same thing a real send shows. */
      if (field('wn_hp') || (openedAt && Date.now() - openedAt < HINT_DWELL)) {
        finish(to || 'them');
        return;
      }
      if (hintsRecent().length >= HINT_MAX) {
        say(copy('limit-text', 'That is a few hints already. Try again a little later.'), true);
        return;
      }
      if (!list.length) {
        say(copy('empty-text', 'Save a piece first, then send it on.'), true);
        return;
      }
      if (!from) { say(copy('name-text', 'Your first name, so they know who it is from.'), true); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(to)) { say(copy('email-text', 'That email does not look right.'), true); return; }

      submit.disabled = true;
      say(copy('sending-text', 'Sending...'));

      var company = form.getAttribute('data-company');
      var metric = form.getAttribute('data-metric') || 'Wish List Hint';
      var alertMetric = form.getAttribute('data-metric-alert') || 'Wish List Hint Alert';
      var alertTo = form.getAttribute('data-alert-to');

      hintItems(list).then(function (items) {
        if (!items.length) throw new Error('nothing to send');

        var props = {
          'Sender name': from,
          'Recipient name': field('to_name'),
          'Note': field('note'),
          'Piece count': items.length,
          'List link': shareUrl(list),
          items: items
        };

        var sends = [klaviyoEvent(company, metric, to, props)];
        if (alertTo) {
          var alertProps = {};
          for (var k in props) { if (Object.prototype.hasOwnProperty.call(props, k)) alertProps[k] = props[k]; }
          alertProps['Recipient email'] = to;
          /* The alert must never take the hint down with it. */
          sends.push(klaviyoEvent(company, alertMetric, alertTo, alertProps).catch(function () { return false; }));
        }
        return Promise.all(sends);
      }).then(function () {
        hintLog();
        finish(to);
      }).catch(function () {
        submit.disabled = false;
        say(copy('error-text', 'That did not send. Try again in a moment, or copy the link instead.'), true);
      });
    });
  }

  function start() {
    paintAll();
    pageActions();
    renderPage();
    hintForm();
    document.addEventListener(EVT, reconcilePage);
    waitForSwish();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
